var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStandard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 15,
    fill: "#FF5F50",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 24.6C15 21.2397 15 19.5595 15.654 18.2761C16.2292 17.1471 17.1471 16.2292 18.2761 15.654C19.5595 15 21.2397 15 24.6 15H30V45H24.6C21.2397 45 19.5595 45 18.2761 44.346C17.1471 43.7708 16.2292 42.8529 15.654 41.7239C15 40.4405 15 38.7603 15 35.4V24.6Z",
    fill: "#FF5F50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15H35.4C38.7603 15 40.4405 15 41.7239 15.654C42.8529 16.2292 43.7708 17.1471 44.346 18.2761C45 19.5595 45 21.2397 45 24.6V30H30V15Z",
    fill: "#FF5F50",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30L45 35.4C45 38.7603 45 40.4405 44.346 41.7239C43.7708 42.8529 42.8529 43.7708 41.7239 44.346C40.4405 45 38.7603 45 35.4 45L30 45L30 30L45 30Z",
    fill: "#FF5F50",
    fillOpacity: 0.15
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandard);
export default __webpack_public_path__ + "static/media/standard.36f1996f.svg";
export { ForwardRef as ReactComponent };